import { useEffect, useState } from 'react'

/**
 * Holds a fast-changing value still for `delay` ms. Used so a search field
 * writes to URL search params once, not once per keystroke.
 */
export function useDebouncedValue<T>(value: T, delay: number): T {
  const [debounced, setDebounced] = useState(value)

  useEffect(() => {
    const timer = setTimeout(() => setDebounced(value), delay)
    return () => clearTimeout(timer)
  }, [value, delay])

  return debounced
}
